import { useContext } from "react";
import { Users } from "Context/context";

export default function useUsers() {
  return useContext(Users);
}
